// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_keychainapis__Buhta_keychain_v1_credential from "./buhta_keychain_v1_credential.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetCredentialRequest = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_credential_service.ml",
      1245,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetCredentialResponse = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_credential_service.ml",
      1308,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListCredentialsRequest = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_credential_service.ml",
      1368,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListCredentialsResponse = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_credential_service.ml",
      1428,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CredentialForm = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_credential_service.ml",
      1494,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateCredentialRequest = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_credential_service.ml",
      1573,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateCredentialResponse = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_credential_service.ml",
      1636,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateCredentialRequest = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_credential_service.ml",
      1697,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateCredentialResponse = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_credential_service.ml",
      1760,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DeleteCredentialRequest = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_credential_service.ml",
      1820,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DeleteCredentialResponse = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_credential_service.ml",
      1878,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.keychain.v1.GetCredentialRequest";
}

function make(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          id: id,
          expand: expand
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.int64_int,
          0
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.int64_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "expand",
                        "expand"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.GetCredentialRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$1(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.GetCredentialRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetCredentialRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.keychain.v1.GetCredentialResponse";
}

function make$1(credential, param) {
  return {
          credential: credential
        };
}

const $$let = Buhta_keychainapis__Buhta_keychain_v1_credential.Buhta.Keychain.V1.Credential;

const merge_credential = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "credential",
            "credential"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          credential: Curry._2(merge_credential, t1.credential, t2.credential)
        };
}

function spec$1(param) {
  const $$let = Buhta_keychainapis__Buhta_keychain_v1_credential.Buhta.Keychain.V1.Credential;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "credential",
                    "credential"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.credential);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(credential) {
  return {
          credential: credential
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.GetCredentialResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.credential);
  };
}

function constructor$3(credential) {
  return {
          credential: credential
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.GetCredentialResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetCredentialResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.keychain.v1.ListCredentialsRequest";
}

function make$2(grid, param) {
  return {
          grid: grid
        };
}

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "grid",
                    "grid"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(grid) {
  return {
          grid: grid
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.ListCredentialsRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.grid);
  };
}

function constructor$5(grid) {
  return {
          grid: grid
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.ListCredentialsRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListCredentialsRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.keychain.v1.ListCredentialsResponse";
}

function make$3(credentialsOpt, param) {
  const credentials = credentialsOpt !== undefined ? credentialsOpt : /* [] */0;
  return {
          credentials: credentials
        };
}

const $$let$2 = Buhta_keychainapis__Buhta_keychain_v1_credential.Buhta.Keychain.V1.Credential;

const merge_credentials = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "credentials",
            "credentials"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          credentials: Curry._2(merge_credentials, t1.credentials, t2.credentials)
        };
}

function spec$3(param) {
  const $$let = Buhta_keychainapis__Buhta_keychain_v1_credential.Buhta.Keychain.V1.Credential;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "credentials",
                    "credentials"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.credentials);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(credentials) {
  return {
          credentials: credentials
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.ListCredentialsResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.credentials);
  };
}

function constructor$7(credentials) {
  return {
          credentials: credentials
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.ListCredentialsResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListCredentialsResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$4(param) {
  return ".buhta.keychain.v1.CredentialForm";
}

function make$4(nameOpt, usernameOpt, passwordOpt, websiteOpt, memoOpt, tagOpt, expire_dateOpt, param) {
  const name = nameOpt !== undefined ? nameOpt : "";
  const username = usernameOpt !== undefined ? usernameOpt : "";
  const password = passwordOpt !== undefined ? passwordOpt : "";
  const website = websiteOpt !== undefined ? websiteOpt : "";
  const memo = memoOpt !== undefined ? memoOpt : "";
  const tag = tagOpt !== undefined ? tagOpt : "";
  const expire_date = expire_dateOpt !== undefined ? expire_dateOpt : "";
  return {
          name: name,
          username: username,
          password: password,
          website: website,
          memo: memo,
          tag: tag,
          expire_date: expire_date
        };
}

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_username = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "username",
            "username"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_password = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "password",
            "password"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_website = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "website",
            "website"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_memo = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "memo",
            "memo"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_tag = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            6,
            "tag",
            "tag"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_expire_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "expire_date",
            "expireDate"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$4(t1, t2) {
  return {
          name: Curry._2(merge_name, t1.name, t2.name),
          username: Curry._2(merge_username, t1.username, t2.username),
          password: Curry._2(merge_password, t1.password, t2.password),
          website: Curry._2(merge_website, t1.website, t2.website),
          memo: Curry._2(merge_memo, t1.memo, t2.memo),
          tag: Curry._2(merge_tag, t1.tag, t2.tag),
          expire_date: Curry._2(merge_expire_date, t1.expire_date, t2.expire_date)
        };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "name",
                    "name"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "username",
                        "username"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "password",
                            "password"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "website",
                                "website"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "memo",
                                    "memo"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string,
                                  ""
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        6,
                                        "tag",
                                        "tag"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string,
                                      ""
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            7,
                                            "expire_date",
                                            "expireDate"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string,
                                          ""
                                        ]), Ocaml_protoc_plugin__Spec.nil)))))));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._8(serialize$4, writer, param.name, param.username, param.password, param.website, param.memo, param.tag, param.expire_date);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(name, username, password, website, memo, tag, expire_date) {
  return {
          name: name,
          username: username,
          password: password,
          website: website,
          memo: memo,
          tag: tag,
          expire_date: expire_date
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.CredentialForm", spec$4(undefined))(options);
  return function (param) {
    return Curry._7(serialize, param.name, param.username, param.password, param.website, param.memo, param.tag, param.expire_date);
  };
}

function constructor$9(name, username, password, website, memo, tag, expire_date) {
  return {
          name: name,
          username: username,
          password: password,
          website: website,
          memo: memo,
          tag: tag,
          expire_date: expire_date
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.CredentialForm", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CredentialForm, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.keychain.v1.CreateCredentialRequest";
}

function make$5(org_idOpt, form, param) {
  const org_id = org_idOpt !== undefined ? org_idOpt : 0;
  return {
          org_id: org_id,
          form: form
        };
}

const merge_org_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "org_id",
            "orgId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_form = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "form",
            "form"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: CredentialForm.name,
                make: CredentialForm.make,
                from_proto: CredentialForm.from_proto,
                from_proto_exn: CredentialForm.from_proto_exn,
                to_proto: CredentialForm.to_proto,
                to_proto$p: CredentialForm.to_proto$p,
                merge: CredentialForm.merge,
                to_json: CredentialForm.to_json,
                from_json_exn: CredentialForm.from_json_exn,
                from_json: CredentialForm.from_json
              })
        ]));

function merge$5(t1, t2) {
  return {
          org_id: Curry._2(merge_org_id, t1.org_id, t2.org_id),
          form: Curry._2(merge_form, t1.form, t2.form)
        };
}

function spec$5(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "org_id",
                    "orgId"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "form",
                        "form"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: CredentialForm.name,
                            make: CredentialForm.make,
                            from_proto: CredentialForm.from_proto,
                            from_proto_exn: CredentialForm.from_proto_exn,
                            to_proto: CredentialForm.to_proto,
                            to_proto$p: CredentialForm.to_proto$p,
                            merge: CredentialForm.merge,
                            to_json: CredentialForm.to_json,
                            from_json_exn: CredentialForm.from_json_exn,
                            from_json: CredentialForm.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry._3(serialize$5, writer, param.org_id, param.form);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(org_id, form) {
  return {
          org_id: org_id,
          form: form
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.CreateCredentialRequest", spec$5(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.org_id, param.form);
  };
}

function constructor$11(org_id, form) {
  return {
          org_id: org_id,
          form: form
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.CreateCredentialRequest", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateCredentialRequest, {
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

function name$6(param) {
  return ".buhta.keychain.v1.CreateCredentialResponse";
}

function make$6(credential, param) {
  return {
          credential: credential
        };
}

const $$let$3 = Buhta_keychainapis__Buhta_keychain_v1_credential.Buhta.Keychain.V1.Credential;

const merge_credential$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "credential",
            "credential"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge$6(t1, t2) {
  return {
          credential: Curry._2(merge_credential$1, t1.credential, t2.credential)
        };
}

function spec$6(param) {
  const $$let = Buhta_keychainapis__Buhta_keychain_v1_credential.Buhta.Keychain.V1.Credential;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "credential",
                    "credential"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
    });

function to_proto$p$6(writer, param) {
  Curry._2(serialize$6, writer, param.credential);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(credential) {
  return {
          credential: credential
        };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
    });

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$6, writer);
            });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.CreateCredentialResponse", spec$6(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.credential);
  };
}

function constructor$13(credential) {
  return {
          credential: credential
        };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.CreateCredentialResponse", spec$6(undefined), constructor$13);
    });

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$6, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateCredentialResponse, {
      make: make$6,
      to_proto: to_proto$6,
      from_proto: from_proto$6,
      to_json: to_json$6,
      from_json: from_json$6,
      name: name$6,
      merge: merge$6,
      to_proto$p: to_proto$p$6,
      from_proto_exn: from_proto_exn$6,
      from_json_exn: from_json_exn$6
    });

function name$7(param) {
  return ".buhta.keychain.v1.UpdateCredentialRequest";
}

function make$7(idOpt, form, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
          id: id,
          form: form
        };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.int64_int,
          0
        ]));

const merge_form$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "form",
            "form"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: CredentialForm.name,
                make: CredentialForm.make,
                from_proto: CredentialForm.from_proto,
                from_proto_exn: CredentialForm.from_proto_exn,
                to_proto: CredentialForm.to_proto,
                to_proto$p: CredentialForm.to_proto$p,
                merge: CredentialForm.merge,
                to_json: CredentialForm.to_json,
                from_json_exn: CredentialForm.from_json_exn,
                from_json: CredentialForm.from_json
              })
        ]));

function merge$7(t1, t2) {
  return {
          id: Curry._2(merge_id$1, t1.id, t2.id),
          form: Curry._2(merge_form$1, t1.form, t2.form)
        };
}

function spec$7(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.int64_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "form",
                        "form"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: CredentialForm.name,
                            make: CredentialForm.make,
                            from_proto: CredentialForm.from_proto,
                            from_proto_exn: CredentialForm.from_proto_exn,
                            to_proto: CredentialForm.to_proto,
                            to_proto$p: CredentialForm.to_proto$p,
                            merge: CredentialForm.merge,
                            to_json: CredentialForm.to_json,
                            from_json_exn: CredentialForm.from_json_exn,
                            from_json: CredentialForm.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
    });

function to_proto$p$7(writer, param) {
  Curry._3(serialize$7, writer, param.id, param.form);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(id, form) {
  return {
          id: id,
          form: form
        };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
    });

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$7, writer);
            });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.UpdateCredentialRequest", spec$7(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.form);
  };
}

function constructor$15(id, form) {
  return {
          id: id,
          form: form
        };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.UpdateCredentialRequest", spec$7(undefined), constructor$15);
    });

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$7, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateCredentialRequest, {
      make: make$7,
      to_proto: to_proto$7,
      from_proto: from_proto$7,
      to_json: to_json$7,
      from_json: from_json$7,
      name: name$7,
      merge: merge$7,
      to_proto$p: to_proto$p$7,
      from_proto_exn: from_proto_exn$7,
      from_json_exn: from_json_exn$7
    });

function name$8(param) {
  return ".buhta.keychain.v1.UpdateCredentialResponse";
}

function make$8(credential, param) {
  return {
          credential: credential
        };
}

const $$let$4 = Buhta_keychainapis__Buhta_keychain_v1_credential.Buhta.Keychain.V1.Credential;

const merge_credential$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "credential",
            "credential"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

function merge$8(t1, t2) {
  return {
          credential: Curry._2(merge_credential$2, t1.credential, t2.credential)
        };
}

function spec$8(param) {
  const $$let = Buhta_keychainapis__Buhta_keychain_v1_credential.Buhta.Keychain.V1.Credential;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "credential",
                    "credential"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
    });

function to_proto$p$8(writer, param) {
  Curry._2(serialize$8, writer, param.credential);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(credential) {
  return {
          credential: credential
        };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
    });

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$8, writer);
            });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.UpdateCredentialResponse", spec$8(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.credential);
  };
}

function constructor$17(credential) {
  return {
          credential: credential
        };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.UpdateCredentialResponse", spec$8(undefined), constructor$17);
    });

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$8, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateCredentialResponse, {
      make: make$8,
      to_proto: to_proto$8,
      from_proto: from_proto$8,
      to_json: to_json$8,
      from_json: from_json$8,
      name: name$8,
      merge: merge$8,
      to_proto$p: to_proto$p$8,
      from_proto_exn: from_proto_exn$8,
      from_json_exn: from_json_exn$8
    });

function name$9(param) {
  return ".buhta.keychain.v1.DeleteCredentialRequest";
}

function make$9(idOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
          id: id
        };
}

const merge_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.int64_int,
          0
        ]));

function merge$9(t1, t2) {
  return {
          id: Curry._2(merge_id$2, t1.id, t2.id)
        };
}

function spec$9(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.int64_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$9(undefined));
    });

function to_proto$p$9(writer, param) {
  Curry._2(serialize$9, writer, param.id);
}

function to_proto$9(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$9(writer, t);
  return writer;
}

function constructor$18(id) {
  return {
          id: id
        };
}

const from_proto_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$9(undefined), constructor$18);
    });

function from_proto$9(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$9, writer);
            });
}

function to_json$9(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.DeleteCredentialRequest", spec$9(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.id);
  };
}

function constructor$19(id) {
  return {
          id: id
        };
}

const from_json_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.DeleteCredentialRequest", spec$9(undefined), constructor$19);
    });

function from_json$9(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$9, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DeleteCredentialRequest, {
      make: make$9,
      to_proto: to_proto$9,
      from_proto: from_proto$9,
      to_json: to_json$9,
      from_json: from_json$9,
      name: name$9,
      merge: merge$9,
      to_proto$p: to_proto$p$9,
      from_proto_exn: from_proto_exn$9,
      from_json_exn: from_json_exn$9
    });

function name$10(param) {
  return ".buhta.keychain.v1.DeleteCredentialResponse";
}

function make$10(param) {
  
}

function merge$10(param, param$1) {
  
}

const serialize$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
    });

function to_proto$p$10(writer, param) {
  Curry._1(serialize$10, writer);
}

function to_proto$10(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$10, writer);
  return writer;
}

const from_proto_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_proto$10(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_proto_exn$10, writer);
            });
}

function to_json$10(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.DeleteCredentialResponse", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.DeleteCredentialResponse", Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_json$10(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_json_exn$10, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DeleteCredentialResponse, {
      make: make$10,
      to_proto: to_proto$10,
      from_proto: from_proto$10,
      to_json: to_json$10,
      from_json: from_json$10,
      name: name$10,
      merge: merge$10,
      to_proto$p: to_proto$p$10,
      from_proto_exn: from_proto_exn$10,
      from_json_exn: from_json_exn$10
    });

const getCredential_0 = {
  name: GetCredentialRequest.name,
  make: GetCredentialRequest.make,
  from_proto: GetCredentialRequest.from_proto,
  from_proto_exn: GetCredentialRequest.from_proto_exn,
  to_proto: GetCredentialRequest.to_proto,
  to_proto$p: GetCredentialRequest.to_proto$p,
  merge: GetCredentialRequest.merge,
  to_json: GetCredentialRequest.to_json,
  from_json_exn: GetCredentialRequest.from_json_exn,
  from_json: GetCredentialRequest.from_json
};

const getCredential_1 = {
  name: GetCredentialResponse.name,
  make: GetCredentialResponse.make,
  from_proto: GetCredentialResponse.from_proto,
  from_proto_exn: GetCredentialResponse.from_proto_exn,
  to_proto: GetCredentialResponse.to_proto,
  to_proto$p: GetCredentialResponse.to_proto$p,
  merge: GetCredentialResponse.merge,
  to_json: GetCredentialResponse.to_json,
  from_json_exn: GetCredentialResponse.from_json_exn,
  from_json: GetCredentialResponse.from_json
};

const getCredential = [
  getCredential_0,
  getCredential_1
];

const listCredentials_0 = {
  name: ListCredentialsRequest.name,
  make: ListCredentialsRequest.make,
  from_proto: ListCredentialsRequest.from_proto,
  from_proto_exn: ListCredentialsRequest.from_proto_exn,
  to_proto: ListCredentialsRequest.to_proto,
  to_proto$p: ListCredentialsRequest.to_proto$p,
  merge: ListCredentialsRequest.merge,
  to_json: ListCredentialsRequest.to_json,
  from_json_exn: ListCredentialsRequest.from_json_exn,
  from_json: ListCredentialsRequest.from_json
};

const listCredentials_1 = {
  name: ListCredentialsResponse.name,
  make: ListCredentialsResponse.make,
  from_proto: ListCredentialsResponse.from_proto,
  from_proto_exn: ListCredentialsResponse.from_proto_exn,
  to_proto: ListCredentialsResponse.to_proto,
  to_proto$p: ListCredentialsResponse.to_proto$p,
  merge: ListCredentialsResponse.merge,
  to_json: ListCredentialsResponse.to_json,
  from_json_exn: ListCredentialsResponse.from_json_exn,
  from_json: ListCredentialsResponse.from_json
};

const listCredentials = [
  listCredentials_0,
  listCredentials_1
];

const createCredential_0 = {
  name: CreateCredentialRequest.name,
  make: CreateCredentialRequest.make,
  from_proto: CreateCredentialRequest.from_proto,
  from_proto_exn: CreateCredentialRequest.from_proto_exn,
  to_proto: CreateCredentialRequest.to_proto,
  to_proto$p: CreateCredentialRequest.to_proto$p,
  merge: CreateCredentialRequest.merge,
  to_json: CreateCredentialRequest.to_json,
  from_json_exn: CreateCredentialRequest.from_json_exn,
  from_json: CreateCredentialRequest.from_json
};

const createCredential_1 = {
  name: CreateCredentialResponse.name,
  make: CreateCredentialResponse.make,
  from_proto: CreateCredentialResponse.from_proto,
  from_proto_exn: CreateCredentialResponse.from_proto_exn,
  to_proto: CreateCredentialResponse.to_proto,
  to_proto$p: CreateCredentialResponse.to_proto$p,
  merge: CreateCredentialResponse.merge,
  to_json: CreateCredentialResponse.to_json,
  from_json_exn: CreateCredentialResponse.from_json_exn,
  from_json: CreateCredentialResponse.from_json
};

const createCredential = [
  createCredential_0,
  createCredential_1
];

const updateCredential_0 = {
  name: UpdateCredentialRequest.name,
  make: UpdateCredentialRequest.make,
  from_proto: UpdateCredentialRequest.from_proto,
  from_proto_exn: UpdateCredentialRequest.from_proto_exn,
  to_proto: UpdateCredentialRequest.to_proto,
  to_proto$p: UpdateCredentialRequest.to_proto$p,
  merge: UpdateCredentialRequest.merge,
  to_json: UpdateCredentialRequest.to_json,
  from_json_exn: UpdateCredentialRequest.from_json_exn,
  from_json: UpdateCredentialRequest.from_json
};

const updateCredential_1 = {
  name: UpdateCredentialResponse.name,
  make: UpdateCredentialResponse.make,
  from_proto: UpdateCredentialResponse.from_proto,
  from_proto_exn: UpdateCredentialResponse.from_proto_exn,
  to_proto: UpdateCredentialResponse.to_proto,
  to_proto$p: UpdateCredentialResponse.to_proto$p,
  merge: UpdateCredentialResponse.merge,
  to_json: UpdateCredentialResponse.to_json,
  from_json_exn: UpdateCredentialResponse.from_json_exn,
  from_json: UpdateCredentialResponse.from_json
};

const updateCredential = [
  updateCredential_0,
  updateCredential_1
];

const deleteCredential_0 = {
  name: DeleteCredentialRequest.name,
  make: DeleteCredentialRequest.make,
  from_proto: DeleteCredentialRequest.from_proto,
  from_proto_exn: DeleteCredentialRequest.from_proto_exn,
  to_proto: DeleteCredentialRequest.to_proto,
  to_proto$p: DeleteCredentialRequest.to_proto$p,
  merge: DeleteCredentialRequest.merge,
  to_json: DeleteCredentialRequest.to_json,
  from_json_exn: DeleteCredentialRequest.from_json_exn,
  from_json: DeleteCredentialRequest.from_json
};

const deleteCredential_1 = {
  name: DeleteCredentialResponse.name,
  make: DeleteCredentialResponse.make,
  from_proto: DeleteCredentialResponse.from_proto,
  from_proto_exn: DeleteCredentialResponse.from_proto_exn,
  to_proto: DeleteCredentialResponse.to_proto,
  to_proto$p: DeleteCredentialResponse.to_proto$p,
  merge: DeleteCredentialResponse.merge,
  to_json: DeleteCredentialResponse.to_json,
  from_json_exn: DeleteCredentialResponse.from_json_exn,
  from_json: DeleteCredentialResponse.from_json
};

const deleteCredential = [
  deleteCredential_0,
  deleteCredential_1
];

const V1_CredentialService = {
  GetCredential: {
    name: "/buhta.keychain.v1.CredentialService/GetCredential",
    package_name: "buhta.keychain.v1",
    service_name: "CredentialService",
    method_name: "GetCredential",
    $$Request: {
      name: GetCredentialRequest.name,
      make: GetCredentialRequest.make,
      from_proto: GetCredentialRequest.from_proto,
      from_proto_exn: GetCredentialRequest.from_proto_exn,
      to_proto: GetCredentialRequest.to_proto,
      to_proto$p: GetCredentialRequest.to_proto$p,
      merge: GetCredentialRequest.merge,
      to_json: GetCredentialRequest.to_json,
      from_json_exn: GetCredentialRequest.from_json_exn,
      from_json: GetCredentialRequest.from_json
    },
    $$Response: {
      name: GetCredentialResponse.name,
      make: GetCredentialResponse.make,
      from_proto: GetCredentialResponse.from_proto,
      from_proto_exn: GetCredentialResponse.from_proto_exn,
      to_proto: GetCredentialResponse.to_proto,
      to_proto$p: GetCredentialResponse.to_proto$p,
      merge: GetCredentialResponse.merge,
      to_json: GetCredentialResponse.to_json,
      from_json_exn: GetCredentialResponse.from_json_exn,
      from_json: GetCredentialResponse.from_json
    }
  },
  getCredential: getCredential,
  ListCredentials: {
    name: "/buhta.keychain.v1.CredentialService/ListCredentials",
    package_name: "buhta.keychain.v1",
    service_name: "CredentialService",
    method_name: "ListCredentials",
    $$Request: {
      name: ListCredentialsRequest.name,
      make: ListCredentialsRequest.make,
      from_proto: ListCredentialsRequest.from_proto,
      from_proto_exn: ListCredentialsRequest.from_proto_exn,
      to_proto: ListCredentialsRequest.to_proto,
      to_proto$p: ListCredentialsRequest.to_proto$p,
      merge: ListCredentialsRequest.merge,
      to_json: ListCredentialsRequest.to_json,
      from_json_exn: ListCredentialsRequest.from_json_exn,
      from_json: ListCredentialsRequest.from_json
    },
    $$Response: {
      name: ListCredentialsResponse.name,
      make: ListCredentialsResponse.make,
      from_proto: ListCredentialsResponse.from_proto,
      from_proto_exn: ListCredentialsResponse.from_proto_exn,
      to_proto: ListCredentialsResponse.to_proto,
      to_proto$p: ListCredentialsResponse.to_proto$p,
      merge: ListCredentialsResponse.merge,
      to_json: ListCredentialsResponse.to_json,
      from_json_exn: ListCredentialsResponse.from_json_exn,
      from_json: ListCredentialsResponse.from_json
    }
  },
  listCredentials: listCredentials,
  CreateCredential: {
    name: "/buhta.keychain.v1.CredentialService/CreateCredential",
    package_name: "buhta.keychain.v1",
    service_name: "CredentialService",
    method_name: "CreateCredential",
    $$Request: {
      name: CreateCredentialRequest.name,
      make: CreateCredentialRequest.make,
      from_proto: CreateCredentialRequest.from_proto,
      from_proto_exn: CreateCredentialRequest.from_proto_exn,
      to_proto: CreateCredentialRequest.to_proto,
      to_proto$p: CreateCredentialRequest.to_proto$p,
      merge: CreateCredentialRequest.merge,
      to_json: CreateCredentialRequest.to_json,
      from_json_exn: CreateCredentialRequest.from_json_exn,
      from_json: CreateCredentialRequest.from_json
    },
    $$Response: {
      name: CreateCredentialResponse.name,
      make: CreateCredentialResponse.make,
      from_proto: CreateCredentialResponse.from_proto,
      from_proto_exn: CreateCredentialResponse.from_proto_exn,
      to_proto: CreateCredentialResponse.to_proto,
      to_proto$p: CreateCredentialResponse.to_proto$p,
      merge: CreateCredentialResponse.merge,
      to_json: CreateCredentialResponse.to_json,
      from_json_exn: CreateCredentialResponse.from_json_exn,
      from_json: CreateCredentialResponse.from_json
    }
  },
  createCredential: createCredential,
  UpdateCredential: {
    name: "/buhta.keychain.v1.CredentialService/UpdateCredential",
    package_name: "buhta.keychain.v1",
    service_name: "CredentialService",
    method_name: "UpdateCredential",
    $$Request: {
      name: UpdateCredentialRequest.name,
      make: UpdateCredentialRequest.make,
      from_proto: UpdateCredentialRequest.from_proto,
      from_proto_exn: UpdateCredentialRequest.from_proto_exn,
      to_proto: UpdateCredentialRequest.to_proto,
      to_proto$p: UpdateCredentialRequest.to_proto$p,
      merge: UpdateCredentialRequest.merge,
      to_json: UpdateCredentialRequest.to_json,
      from_json_exn: UpdateCredentialRequest.from_json_exn,
      from_json: UpdateCredentialRequest.from_json
    },
    $$Response: {
      name: UpdateCredentialResponse.name,
      make: UpdateCredentialResponse.make,
      from_proto: UpdateCredentialResponse.from_proto,
      from_proto_exn: UpdateCredentialResponse.from_proto_exn,
      to_proto: UpdateCredentialResponse.to_proto,
      to_proto$p: UpdateCredentialResponse.to_proto$p,
      merge: UpdateCredentialResponse.merge,
      to_json: UpdateCredentialResponse.to_json,
      from_json_exn: UpdateCredentialResponse.from_json_exn,
      from_json: UpdateCredentialResponse.from_json
    }
  },
  updateCredential: updateCredential,
  DeleteCredential: {
    name: "/buhta.keychain.v1.CredentialService/DeleteCredential",
    package_name: "buhta.keychain.v1",
    service_name: "CredentialService",
    method_name: "DeleteCredential",
    $$Request: {
      name: DeleteCredentialRequest.name,
      make: DeleteCredentialRequest.make,
      from_proto: DeleteCredentialRequest.from_proto,
      from_proto_exn: DeleteCredentialRequest.from_proto_exn,
      to_proto: DeleteCredentialRequest.to_proto,
      to_proto$p: DeleteCredentialRequest.to_proto$p,
      merge: DeleteCredentialRequest.merge,
      to_json: DeleteCredentialRequest.to_json,
      from_json_exn: DeleteCredentialRequest.from_json_exn,
      from_json: DeleteCredentialRequest.from_json
    },
    $$Response: {
      name: DeleteCredentialResponse.name,
      make: DeleteCredentialResponse.make,
      from_proto: DeleteCredentialResponse.from_proto,
      from_proto_exn: DeleteCredentialResponse.from_proto_exn,
      to_proto: DeleteCredentialResponse.to_proto,
      to_proto$p: DeleteCredentialResponse.to_proto$p,
      merge: DeleteCredentialResponse.merge,
      to_json: DeleteCredentialResponse.to_json,
      from_json_exn: DeleteCredentialResponse.from_json_exn,
      from_json: DeleteCredentialResponse.from_json
    }
  },
  deleteCredential: deleteCredential
};

const V1 = {
  GetCredentialRequest: GetCredentialRequest,
  GetCredentialResponse: GetCredentialResponse,
  ListCredentialsRequest: ListCredentialsRequest,
  ListCredentialsResponse: ListCredentialsResponse,
  CredentialForm: CredentialForm,
  CreateCredentialRequest: CreateCredentialRequest,
  CreateCredentialResponse: CreateCredentialResponse,
  UpdateCredentialRequest: UpdateCredentialRequest,
  UpdateCredentialResponse: UpdateCredentialResponse,
  DeleteCredentialRequest: DeleteCredentialRequest,
  DeleteCredentialResponse: DeleteCredentialResponse,
  CredentialService: V1_CredentialService
};

const Keychain = {
  V1: V1
};

const Buhta = {
  Keychain: Keychain
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetCredentialRequest Not a pure module */
